module.exports = __webpack_public_path__ + "img/gpktwoc_packs.topps.f29d3e0.png";